import styled from 'styled-components';
import { mediaQueryMax, NotificationChip } from 'components';

export const ImageWrap = styled.div`
  position: relative;
  img {
    width: 200px;
  }
  cursor: pointer;
  height: 150px;
  width: 150px;
}
`;
export const StyledCheck = styled.div`
  display: inline-block;
  transform: rotate(45deg);
  height: 12px;
  width: 6px;
  border-bottom: 1.5px solid #78b13f;
  border-right: 1.5px solid #78b13f;
  margin-right: 10px;
  margin-top: 4px;
  margin-left: 4px;
`;

export const StyledMessage = styled.div`
  font-size: 0.7em;
  white-space: nowrap;
  letter-spacing: 1.5px;
  padding: 0px;
  color: #78b13f;
`;

export const StyledContent = styled.div`
  display: flex;
`;

export const NotificationChipWrap = styled.div`
  position: absolute;
  margin-top: 8px;
  padding-left: 1px;
  text-align: center;
  width: 100%;

  p {
    margin: 0;
  }
`;
export const StyledNotificationChip = styled(NotificationChip)`
  padding: 2px 8px 0 8px;
`;

export const ProjectImgContainer = styled.div`
  width: 45px;
  position: absolute;
  bottom: -10px;
  right: -10px;
  padding: 4px;
  background-color: #fff;
  border-radius: 1px;

  img {
    width: 45px;
  }
`;

export const ProjectImgLargerContainer = styled.div`
  width: 75px;
  position: absolute;
  bottom: -10px;
  right: -10px;
  padding: 2px;
  background-color: #fff;
  border-radius: 3px;

  img {
    width: 75px;
  }

  ${mediaQueryMax.medium`
    width: 55px;
    img {
      width: 55px;
    }
  `}
`;
